import { render } from "./QuestionnaireConfiguration.vue?vue&type=template&id=25c46180"
import script from "./QuestionnaireConfiguration.vue?vue&type=script&lang=js"
export * from "./QuestionnaireConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__